import { Reducer } from 'redux';
import {
  ACTION, RequestContainerDefinitions, ReceiveContainerDefinitions,
  RequestMainFavourite, ReceiveMainFavourite, FailedMainFavourite, 
  ClearMainFavourite,
  FailedContainerDefinitions,
  IncreaseExecutionCounter
} from './action-types';
import { DashboardState } from './types-store';

const INITIAL_STATE: DashboardState = {
  layouts: {},
  executionCounter: 0,
  mainFavouriteId: undefined,
  fetchingMainFavourite: false,
  texts: {}
};

/** 
 * REDUCER - For a given state and action, returns the new state. 
 * To support time travel, this must not mutate the old state.
 */
const reducers: ActionMap = {

  [ACTION.INCREASE_EXECUTION_COUNTER]: (state: DashboardState, action: IncreaseExecutionCounter): DashboardState => {
    return {
      ...state,
      executionCounter: state.executionCounter + 1
    };
  },

  [ACTION.REQUEST_CONTAINER_DEFINITIONS]: (state: DashboardState, action: RequestContainerDefinitions): DashboardState => {
    return {
      ...state,
      layouts: {
        ...state.layouts,
        [action.dashboardType]: {
          ...state.layouts[action.dashboardType],
          fetching: true
        }
      }
    };
  },

  [ACTION.RECEIVE_CONTAINER_DEFINITIONS]: (state: DashboardState, action: ReceiveContainerDefinitions): DashboardState => {
    return {
      ...state,
      layouts: {
        ...state.layouts,
        [action.dashboardType]: {
          definition: action.dashboardDefinition,
          fetching: false
        }
      }
    };
  },

  [ACTION.FAILED_CONTAINER_DEFINITIONS]: (state: DashboardState, action: FailedContainerDefinitions): DashboardState => {
    return {
      ...state,
      layouts: {
        ...state.layouts,
        [action.dashboardType]: {
          fetching: false,
          error: true
        }
      }
    };
  },

  [ACTION.REQUEST_MAIN_FAVOURITE]: (state: DashboardState, action: RequestMainFavourite): DashboardState => {
    return {
      ...state,
      fetchingMainFavourite: true
    };
  },

  [ACTION.RECEIVE_MAIN_FAVOURITE]: (state: DashboardState, action: ReceiveMainFavourite): DashboardState => {
    return {
      ...state,
      mainFavouriteId: action.mainFavouriteId,
      fetchingMainFavourite: false
    };
  },
  [ACTION.CLEAR_MAIN_FAVOURITE]: (state: DashboardState, action: ClearMainFavourite): DashboardState => {
    return {
      ...state,
      layouts: {},
      mainFavouriteId: undefined
    };
  },

  [ACTION.FAILED_MAIN_FAVOURITE]: (state: DashboardState, action: FailedMainFavourite): DashboardState => {

    return {
      ...state,
      layouts: {},
      mainFavouriteId: undefined,
      fetchingMainFavourite: false,
      errorFetchingMainFavourite: true
    };
  }
};

export const reducer: Reducer<DashboardState> = (state: DashboardState = INITIAL_STATE, action: any) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};

interface ActionMap {
  [indexer: string]: Reducer<DashboardState>;
}
